const { REACT_APP_VERSION } = process.env;

export const UNITY_REF = {
  loaderUrl: `/Build/product/Product3DModelBuild.loader.js?version=${REACT_APP_VERSION}`,
  dataUrl: `/Build/product/Product3DModelBuild.data?version=${REACT_APP_VERSION}`,
  frameworkUrl: `/Build/product/Product3DModelBuild.framework.js?version=${REACT_APP_VERSION}`,
  codeUrl: `/Build/product/Product3DModelBuild.wasm?version=${REACT_APP_VERSION}`,
};